// src/config/company-config.ts

interface CognitoConfig {
  clientId: string;
  clientSecret: string;
  domainPrefix: string;
  redirectUri: string;
}

interface CompanyConfig {
  match: string;
  cognito: CognitoConfig;
  title: string;
  aiAgentEnabled: boolean;
}

const companyConfig: Record<string, CompanyConfig> = {
  DEFAULT: {
    match: '', // default
    title: 'MIGSO E-Delivery',
    aiAgentEnabled: true,
    cognito: {
      clientId: process.env.REACT_APP_CognitoClientAppId || '',
      clientSecret: process.env.REACT_APP_CognitoClientAppSecret || '',
      domainPrefix: process.env.REACT_APP_COGNITO_DOMAIN_PREFIX || '',
      redirectUri: process.env.REACT_APP_REDIRECT_URI_CODE || '',
    },
  },

  EDELIVERY: {
    match: 'edelivery', // edelivery
    title: 'MIGSO E-Delivery',
    aiAgentEnabled: true,
    cognito: {
      clientId: process.env.REACT_APP_CognitoClientAppId || '',
      clientSecret: process.env.REACT_APP_CognitoClientAppSecret || '',
      domainPrefix: process.env.REACT_APP_COGNITO_DOMAIN_PREFIX || '',
      redirectUri: process.env.REACT_APP_REDIRECT_URI_CODE || '',
    },
  },

  CADUCEUM: {
    match: 'caduceum',
    title: 'Caduceum E-Delivery',
    aiAgentEnabled: false,
    cognito: {
      clientId: process.env.REACT_APP_CADUCEUM_COGNITO_CLIENT_ID || '',
      clientSecret: process.env.REACT_APP_CADUCEUM_COGNITO_CLIENT_SECRET || '',
      domainPrefix: process.env.REACT_APP_CADUCEUM_COGNITO_DOMAIN_PREFIX || '',
      redirectUri: process.env.REACT_APP_CADUCEUM_REDIRECT_URI_CODE || '',
    },
  },
};

export default companyConfig;
